import 'rxjs/add/operator/delay'
import 'rxjs/add/operator/mapTo'

export default action$ =>
  action$
    .ofType('PING')
    .delay(1000)
    .mapTo({ type: 'PONG' })



/** WEBPACK FOOTER **
 ** ./src/epics/pingEpic.js
 **/